export const REQUEST_STARTED = 'REQUEST_STARTED';
export const REQUEST_SUCCESSFUL = 'REQUEST_SUCCESSFUL';
export const REQUEST_FAILED = 'REQUEST_FAILED';
export const RESET_REQUEST = 'RESET_REQUEST';

export function getHubUrl() {

    const location = window.location;

    const firstPart = location.hostname.split(".")[0];

    //handle ships that will be in format backoffice.ship.navigate-marella.com
    if(firstPart === "backoffice") {
        return `${location.origin.replace("backoffice", "hub")}/v1/`;
    }

    // handle ships that will be in format phoenix-backoffice.digitech.world
    // change phoenix-backoffice.digitech.world → phoenix-hub.digitech.world
    if (firstPart.endsWith("-backoffice")) {
        const hubOrigin = location.origin.replace("backoffice.", "hub.");
        return `${hubOrigin}/v1/`;
    }


    // specify the hub to use for localhost (and other hostnames not covered by above rules)
    // return "https://tui-hub-test.digitech.world/v1/";
    // return "http://10.10.160.26:8090/v1/";
    return "https://phoenix-hub.digitech.world/v1/";
    // return "https://hub.ambassador-ambience.castusdev.co.uk/v1/";
    // return "http://localhost:8080/v1/";
}

export function isDevMode() {
    return window.location.hostname === "localhost";
}

export function isRiver() {
    return window.location.hostname.includes("river");
}

export function isMobileDevice(){
    // 640px: tailwindcss small screen breakpoint
    return window.innerWidth < 640;
}

export function isConciergeAllowed(){
    return isDevMode() || window.location.hostname.includes("phoenix");
}

export const PHOENIX_NODES = [
    {
        "id": "4dbfbf5a-fe1a-4776-854a-95da92fa1a7f",
        "name": "MS Aurelia",
        "code": "ARE",
    },
    {
        "id": "9319deab-b655-44aa-bf9d-f284804d03bd",
        "name": "MS Adora",
        "code": "ADO",
    },
    {
        "id": "d0892e4b-44ed-4e97-b127-c98b47ffe073",
        "name": "MS Alena",
        "code": "ALE",
    },
    {
        "id": "d8d13dae-03e0-455f-8d67-4c85c7207c95",
        "name": "MS Andrea",
        "code": "AND",
    },
    {
        "id": "de61846b-f2d5-4e4c-8854-f8e2c3efd673",
        "name": "MS Alisa",
        "code": "ALA",
    },
    {
        "id": "e311ddd5-36bc-4461-8472-7a112756e53b",
        "name": "MS Amadea",
        "code": "AMA",
    }
]

export function getNodeId(){
    try {
        const stored = localStorage.getItem("shipNode");
        if (!stored) return null;

        const { id } = JSON.parse(stored);

        // check if the id from the storage is legit and valid
        if(PHOENIX_NODES.find(node => node.id === id)){
            return id;
        }else{
            return null;
        }
        
    } catch {
        return null;
    }
}